import LocalStorage from '../../data/local-storage';
import AuthService from '../../services/auth-service';
import NotificationService from '../../services/notification-service';

export default class NotificationsModel {
  constructor() {
    this.notifications = [];
    this.isAuthenticated = false;
    this.user = {};
    this.pushSubscription = null;
  }

  loadUserState() {
    const { isAuthenticated, user } = AuthService;
    this.isAuthenticated = isAuthenticated;
    this.user = user || {};

    if (isAuthenticated && user.id) {
      this.notifications = NotificationService.getNotifications();
      this.pushSubscription = LocalStorage.getUserSpecificObject(
        'heliaedu_user_push_subscription',
        user.id
      );
    } else {
      this.notifications = [];
      this.pushSubscription = null;
    }
  }

  getNotifications() {
    return this.notifications.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
  }

  addNotification(title, message) {
    if (!this.isAuthenticated) return null;

    const notification = {
      id: 'notif_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9),
      title: title,
      message: message,
      timestamp: new Date().toISOString()
    };
    NotificationService.addNotification(notification);
    this.notifications = NotificationService.getNotifications();
    return notification;
  }

  removeNotification(notificationId) {
    NotificationService.removeNotification(notificationId);
    this.notifications = NotificationService.getNotifications();
    return true;
  }

  isPushSubscribed() {
    return !!this.pushSubscription;
  }

  setPushSubscription(subscription) {
    this.pushSubscription = subscription;
    
    if (this.isAuthenticated && this.user.id) {
      const key = LocalStorage.getUserSpecificKey(
        'heliaedu_user_push_subscription',
        this.user.id
      );
      if (subscription) {
        LocalStorage.setObject(key, subscription);
      } else {
        LocalStorage.removeItem(key);
      }
    }
  }

  getNotificationPermissionStatus() {
    if (!('Notification' in window)) {
      return 'not-supported';
    }
    return Notification.permission;
  }
}